import { DispatchLoading, DispatchType, ResponseValid } from "domain/utils/ReactUtils";
import { AppThunk } from "base/src/utils/reducerUtil";
import { PagarRequest } from "domain/types/_carteira/premiacao/pagarRequest";
import { PAGAMENTO_PREMIACAO } from 'domain/types/_carteira/premiacao/premiacao';
import { PremiacaoService } from "../../../../services/_carteira/premiacao/premiacaoService";
import { StateType } from "domain/types/base/base";

const _PremiacaoService = new PremiacaoService();
export function PagarPremiacao(request: PagarRequest[], carteiraId: number, callback: () => void): AppThunk {
  return async (dispatch) => {
    dispatch(DispatchLoading(PAGAMENTO_PREMIACAO, DispatchType.LOADING, 'Realizando pagamento...', StateType.Master));

    const asyncResponse = await _PremiacaoService.Pagar(request, carteiraId);

    if (ResponseValid(asyncResponse)) {
      dispatch({
        payload: asyncResponse,
        type: PAGAMENTO_PREMIACAO
      });

      callback();

      window.dispatchEvent(new Event("balanceUpdated"));
    } else {
      dispatch({
        payload: asyncResponse,
        type: PAGAMENTO_PREMIACAO,
      });
      dispatch(DispatchLoading(PAGAMENTO_PREMIACAO, DispatchType.ERROR, "Erro ao realizar depósito! ", StateType.Master));
    }
  };
}



